export default function () {
  return Math.random().toString(36).slice(4)
}
